<template>
  <div class="hello">
    <div class="search container-fluid mb-3">
      <input @input="searchCommande(currentPage)" v-model="searchTerm" type="text" placeholder="Rechercher une commande...">
    </div>    
    <div v-if="nb_pages > 1" class="pagination container">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchCommande(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>
    <div v-if="confirmationMessage" class="alert alert-success" role="alert">
      {{ confirmationMessage }}
  </div>
      <table class="demandesListe">
        <thead>
          <tr>
            <th>Numéro de commande client</th>
            <th>Affaire</th>
            <th>Quantité</th>
            <th>Delais</th>
          </tr>
        </thead>
        <tbody>
          <!-- Check if the articles array is empty -->
          <template v-if="commandes.length === 0">
            <tr>
              <td colspan="6" class="text-center">Pas de commandes en cours.</td>
            </tr>
          </template>
        
          <!-- Render table rows for each article -->
          <template v-else>
              <tr v-for="(commande, index) in commandes" :key="commande.id" class="demandes" :class="index % 2 === 0 ? 'ligne-claire' : 'ligne-foncee'"> 
                <td>{{ commande.cocde }}</td>
                <td>{{ commande.naf }}</td>
                <td>{{ commande.qte }}</td>
                <td>{{ formatDate(commande.delais) }}</td>
              
              </tr>
          </template>
        </tbody>
        
      </table>
  
    <div v-if="nb_pages > 1" class="pagination container  mt-4">
      <div class="pagination-pages">
        <span>Page:</span>
        <select @change="searchCommande(parseInt($event.target.value))">
          <option v-for="page in nb_pages" :key="page" :value="page" :selected="currentPage === page">{{ page }}</option>
        </select>
        <span>sur {{ nb_pages }}</span>
      </div>
    </div>

    <!-- Loader -->
    <div v-if="isLoading" class="loader">
      <div id="loading"></div>
    </div>
  </div>
</template>

<script>
import axios from '@/components/axiosConfig.js'




export default {
  data() {
    return {
      commandes: [],
      nb_pages:1,
      currentPage: 1,
      searchTerm: '',
      isLoading: false,
      sortColumn: '',
      sortDirection: 'asc',
      loggedInRole: null,
      client: '',
    }
  },
  created() {
    
  
  },
  mounted() {
    this.client = this.$route.params.client;

    

    // Récupération des données de l'API PHP
    this.currentPage = parseInt(this.$route.query.page) || 1;
    this.searchTerm = this.$route.query.searchTerm || '';
    this.sortColumn = this.$route.query.sortColumn || '';
    this.sortDirection = this.$route.query.sortDirection || '';

    this.searchCommande(this.currentPage);
    
  },
  watch: {
    $route(to) {
      this.currentPage = parseInt(to.query.page) || 1;
      this.searchTerm = to.query.searchTerm || '';
      this.sortColumn = to.query.sortColumn || '';
      this.sortDirection = to.query.sortDirection || '';

      this.searchCommande(this.currentPage);
    }
  },
  methods: {
    searchCommande(page) {
      this.isLoading = true; // Show loader
      axios.post('https://www.simef.fr/espace-client/api/getCommandes.php', {
        page: page,
        searchTerm: this.searchTerm,
        client: this.client,
        sortColumn: this.sortColumn,
        sortDirection: this.sortDirection,
      })
      .then(response => {
        this.commandes = response.data.commandes;
        this.nb_pages = response.data.nb_pages;
        this.currentPage = page;

      })
      .catch(error => {
        console.error(error);
        

      })
      .finally(() => {
        this.isLoading = false; // Hide loader
      });

      this.$router.push({
          query: {
            page: page,
            searchTerm: this.searchTerm,
            sortColumn: this.sortColumn,
            sortDirection: this.sortDirection,
          }
        });
    },
    handleColumnSort(column) {
      if (this.sortColumn === column) {
        // Reverse the sorting direction if the same column is clicked again
        this.sortDirection = this.sortDirection === 'asc' ? 'desc' : 'asc';
      } else {
        // Sort the clicked column in ascending order by default
        this.sortColumn = column;
        this.sortDirection = 'asc';
      }

      // Call the searchArticles method with the current page and sorting parameters
      this.searchCommande(this.currentPage);
    },
    formatDate(date) {
      // Extraire les parties de la date
      const year = date.substr(0, 4);
      const month = date.substr(4, 2);
      const day = date.substr(6, 2);

      // Concaténer les parties dans l'ordre souhaité
      const formattedDate = `${day}-${month}-${year}`;

      // Renvoyer la date formatée
      return formattedDate;
    },
  }
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss">
  $primary: #2b358d;
  .small {
    font-size:13px;

  }
  select {
    background: #f5f5f5;
    border: 0px;
    padding: 12px 15px;
    border: 1px solid lightgrey;
    margin-right: 10px;
  }
  #loading {
    display: inline-block;
    width: 50px;
    height: 50px;
    border: 3px solid rgba(255,255,255,.3);
    border-radius: 50%;
    border-top-color: #fff;
    animation: spin 1s ease-in-out infinite;
    -webkit-animation: spin 1s ease-in-out infinite;
  }
  
  @keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  @-webkit-keyframes spin {
    to { -webkit-transform: rotate(360deg); }
  }
  button {
    background: $primary;
    border: none;
    padding: 12px 20px;
    color: #fff;
  }
  .check {
    margin-right: 10px;
  }
 

  table.demandesListe {
    width: 100%;
    tbody {

      a {
        font-size: 0.9rem;
        color: #2b358d;
        display: contents;
      }
    }
    thead {
      background: #2b358d!important;
      color: #fff!important;
      position: sticky;
      top: 0px;
    }
    th, td {
      padding: 8px;
      font-size: 0.9rem;
      font-weight: 500;
      color: #1d1d20;
      text-align: center;
    }
    th {
      color: #fff!important;
    }
    .ligne-claire {
      background-color: #f7f7f7;
    }
    .ligne-foncee {
      background-color: #ebebeb;
    }
  }
  
  .search {
    margin-bottom: 5px!important;
      @media screen and (max-width:992px) {
        input[type="text"] {
            margin-bottom: 10px;
        }
      }
  }


  .text-danger {
    color: rgb(255, 17, 17);
  }
  .search {
    input[type="text"], select {
        background: #f5f5f5;
        border: 0px;
        padding: 12px 20px;
        border: 1px solid lightgrey;
        margin-right: 10px;
        &:focus-visible {
          outline: $primary auto 1px;
          border-color: $primary;
          border-radius: 0px;
        }
    }
    select {
      @media screen and (max-width:992px) {
            margin-bottom: 10px;
        
      }
    }
  }
  .loader {
    height: 100%;
    width: 100%;
    position: fixed;
    background: #0b0b0baa;
    top: 0;
    left: 0;
    color: #fff;
    display: flex;
    align-items: center;
    justify-content: center;
z-index: 99999;
  }
  .archiver, .relier {
    a {
      height: 100%;
      width: 100%;
      display: flex!important;
      align-items: center;
      justify-content: center;
      svg {
        margin-right: 5px;
        height: 22px;
        width: 22px;
      }
    }
  }
  .relier {
    svg {
      height: 22px;
      width: 22px;
    }
  }

  .comTab {
    width:40%;
    text-align:justify;
    word-break: break-all;
   @media screen and (max-width: 992px) {
    min-width: 450px;
   }
  }
</style>
